/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import ProductService from '../services/ProductService';
import moment from "moment";
import { showLoading } from 'react-global-loading';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class AboutUs extends React.Component {
  constructor(props) {
    super(props);
    showLoading(false);
    this.state = {

    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {

    return (

      <div className="container">
        <h2 className="abthdn">About the Ministry</h2>
        <p className="abtpara">
          The Ministry of Ayush was formed on the 9th of November 2014 with a vision of reviving the profound knowledge of our ancient systems of medicine and ensuring the optimal development and propagation of the Ayush systems of healthcare. Earlier, the Department of Indian System of Medicine and Homoeopathy (ISM&H) formed in 1995, was responsible for the development of these systems. It was then renamed as the Department of Ayurveda, Yoga, and Naturopathy, Unani, Siddha and Homoeopathy (Ayush) in November 2003 with focused attention towards education and research in Ayurveda, Yoga and Naturopathy, Unani, Siddha, and Homoeopathy.</p>
      </div>
    );
  }
}
export default AboutUs;